/**
 * Add Chemical (Raw Material) Configuration
 * Uses custom submit handler to support dual unit/total quantities.
 * quantity entered = number of units (drums/bags/totes/custom)
 * total_quantity   = unit_quantity * item.primary_unit_quantity
 */

import { submitAddStockChemical } from '../AddInventoryStepper/chemicalStepperHelpers';

export const addChemicalConfig = {
  type:              'chemicals',
  displayName:       'Chemicals',
  tableName:         'raw_materials',
  inventoryTable:    'raw_materials_inventory',
  itemsTable:        'raw_materials_inventory_items',
  transactionsTable: 'raw_materials_transactions',
  itemIdField:       'raw_material_id',

  // Override the generic submitAddStock in AddInventoryStepper
  customSubmitAdd: submitAddStockChemical,

  formFields: [
    { name: 'raw_material_id', label: 'Chemical',       type: 'select',   required: true,  section: 'basic' },
    { name: 'location_id',     label: 'Location',       type: 'select',   required: true,  section: 'basic' },
    { name: 'quantity',        label: 'Unit Quantity',  type: 'number',   required: true,  min: 0.0001, step: 0.0001, section: 'basic' },
    { name: 'lot_number',      label: 'Lot Number',     type: 'text',     required: true,  section: 'lot' },
    { name: 'batch_number',    label: 'Batch Number',   type: 'text',     required: true,  section: 'lot' },
    { name: 'supplier_id',     label: 'Vendor',         type: 'select',   required: false, section: 'vendor' },
    { name: 'po_number',       label: 'PO Number',      type: 'text',     required: false, section: 'vendor' },
    { name: 'po_date',         label: 'PO Date',        type: 'date',     required: false, section: 'vendor' },
    { name: 'invoice_number',  label: 'Invoice Number', type: 'text',     required: false, section: 'vendor' },
    { name: 'invoice_date',    label: 'Invoice Date',   type: 'date',     required: false, section: 'vendor' },
    { name: 'invoice_document', label: 'Invoice',       type: 'file',     required: false, accept: '.pdf,.jpg,.jpeg,.png', section: 'documents' },
    { name: 'po_document',     label: 'PO Document',    type: 'file',     required: false, accept: '.pdf,.jpg,.jpeg,.png', section: 'documents' },
    { name: 'coa_document',    label: 'COA Document',   type: 'file',     required: false, accept: '.pdf,.jpg,.jpeg,.png', section: 'documents' },
    { name: 'msds_document',   label: 'MSDS Document',  type: 'file',     required: false, accept: '.pdf,.jpg,.jpeg,.png', section: 'documents' },
    { name: 'bol_document',    label: 'BOL Document',   type: 'file',     required: false, accept: '.pdf,.jpg,.jpeg,.png', section: 'documents' },
    { name: 'notes',           label: 'Notes',          type: 'textarea', required: false, rows: 3, section: 'additional' }
  ],

  validationRules: {
    quantity: (value) => {
      const num = parseFloat(value);
      if (isNaN(num) || num <= 0) return 'Quantity must be a positive number';
      return null;
    }
  }
};

export default addChemicalConfig;
